/* 三國逗陣打 · 武將史傳：角色分頁的「歷史上的他」
 * life：生卒年（「?」表示史書未載）；from：籍貫；bio：正史記載的生平；novel：《三國演義》或民間傳說與正史不同之處；src：主要出處。
 * 生平以陳壽《三國志》與裴松之注為準，演義情節只放在 novel，不混進 bio。 */
import { SG } from '../core/sg.ts';

const LORE = {
  // ---------- 蜀 ----------
  liubei: { life: '161–223', from: '幽州涿郡涿縣', src: '《三國志·蜀書·先主傳》',
    bio: '自稱漢景帝之子中山靖王劉勝之後，少時家貧，以販履織蓆為業。黃巾之亂起兵，輾轉依附公孫瓚、陶謙、曹操、袁紹、劉表，屢敗屢起。赤壁之戰後取荊州南部，214 年得益州，219 年奪漢中稱漢中王，221 年於成都稱帝，國號漢（史稱蜀漢）。為報關羽之仇東征孫權，222 年夷陵之戰大敗，次年病逝白帝城，託孤諸葛亮。',
    novel: '「桃園三結義」出自演義；正史只說劉備與關、張「寢則同床，恩若兄弟」。' },
  guanyu: { life: '?–220', from: '河東郡解縣', src: '《三國志·蜀書·關羽傳》',
    bio: '亡命奔涿郡，隨劉備起兵。200 年兵敗為曹操所擒，拜偏將軍，於白馬之戰刺殺袁紹大將顏良，封漢壽亭侯，隨後封還賞賜歸劉備。劉備入蜀後督守荊州。219 年北攻樊城，水淹七軍擒于禁、斬龐德，威震華夏；但孫權遣呂蒙襲取江陵，關羽敗走麥城，被俘斬殺。',
    novel: '「過五關斬六將」「溫酒斬華雄」「華容道義釋曹操」都是演義虛構；華雄實為孫堅所斬。青龍偃月刀也是後世附會。' },
  zhangfei: { life: '?–221', from: '幽州涿郡', src: '《三國志·蜀書·張飛傳》',
    bio: '與關羽同隨劉備起兵，關羽年長，張飛以兄事之。208 年長坂之敗，率二十騎斷後，據水斷橋，瞋目橫矛喝道「身是張益德也，可來共決死！」曹軍無人敢近。入蜀時義釋嚴顏，後於宕渠大破張郃。為人敬重君子而不恤士卒，221 年出征前被部將范彊、張達所殺。',
    novel: '正史字「益德」，演義改作「翼德」；「鞭打督郵」正史是劉備所為。' },
  zhaoyun: { life: '?–229', from: '常山郡真定縣', src: '《三國志·蜀書·趙雲傳》及裴注《趙雲別傳》',
    bio: '先從公孫瓚，後歸劉備，掌管騎兵。長坂之敗時懷抱幼主劉禪、保護甘夫人脫險。劉備入蜀後留營漢中，漢水一役以空營計嚇退曹軍，劉備稱讚「子龍一身都是膽也」。228 年隨諸葛亮北伐，以疑兵牽制曹真於箕谷，兵敗而能斂眾固守，次年病逝，諡順平侯。',
    novel: '演義中「長坂坡七進七出」與「五虎上將」稱號都是誇大；正史中趙雲官位不高，傳記篇幅很短。' },
  machao: { life: '176–222', from: '扶風郡茂陵縣', src: '《三國志·蜀書·馬超傳》',
    bio: '涼州軍閥馬騰之子。211 年聯合韓遂等關西諸將起兵反曹，於潼關、渭南與曹操對峙，被曹操以離間計擊潰；父親馬騰與家族在鄴城被誅。後投張魯，214 年歸劉備，兵臨成都使劉璋膽寒出降。官至驃騎將軍、涼州牧，47 歲病逝。',
    novel: '演義寫馬超為報父仇而起兵；正史順序相反，是馬超先反，曹操才誅殺馬騰全族。' },
  huangzhong: { life: '?–220', from: '南陽郡', src: '《三國志·蜀書·黃忠傳》',
    bio: '原為劉表部將，與劉表從子劉磐守長沙攸縣，曹操取荊州後歸韓玄，後歸劉備。入蜀時常先登陷陣，勇冠三軍。219 年定軍山之戰，率軍居高臨下，金鼓震天，一戰斬殺曹軍主帥夏侯淵，升為征西將軍，次年病逝。',
    novel: '「老將黃忠」與關羽長沙大戰都是演義情節；正史沒有記載他的年紀。' },
  zhugeliang: { life: '181–234', from: '琅邪郡陽都縣', src: '《三國志·蜀書·諸葛亮傳》',
    bio: '早年隱居隆中，自比管仲、樂毅。207 年劉備三顧茅廬，獻「隆中對」三分天下之策。赤壁之戰前出使東吳促成孫劉聯盟。劉備稱帝後任丞相，受遺詔輔佐劉禪，平定南中，前後五次北伐曹魏，234 年病逝於五丈原軍中。治國賞罰分明，陳壽評為「識治之良才」。',
    novel: '「草船借箭」原是孫權的事、「借東風」「空城計」「七星燈續命」都是演義虛構；陳壽認為他「應變將略，非其所長」。' },
  pangtong: { life: '179–214', from: '襄陽', src: '《三國志·蜀書·龐統傳》',
    bio: '號「鳳雛」，少時被司馬徽稱為南州士之冠冕。先任周瑜功曹，後歸劉備，起初只任耒陽縣令而不理政事被免，經魯肅、諸葛亮推薦才受重用，與諸葛亮同為軍師中郎將。隨劉備入蜀，獻上中下三策，劉備取中策。214 年圍攻雒城時中流矢身亡，年僅 36 歲。',
    novel: '「連環計」與「落鳳坡」都是演義虛構。' },
  weiyan: { life: '?–234', from: '義陽郡', src: '《三國志·蜀書·魏延傳》',
    bio: '以部曲隨劉備入蜀，219 年劉備越級拔擢他為漢中太守、鎮守漢中，舉軍皆驚；他答「若曹操舉天下而來，請為大王拒之」。善養士卒、勇猛過人。北伐時屢請領兵萬人由子午谷奇襲長安，諸葛亮不許。諸葛亮死後與楊儀爭權，兵敗被馬岱追斬，夷三族。',
    novel: '演義說他「腦後有反骨」，正史認為他並無投魏之意，只是想除掉楊儀。' },
  jiangwei: { life: '202–264', from: '天水郡冀縣', src: '《三國志·蜀書·姜維傳》',
    bio: '原為曹魏天水郡中郎，228 年諸葛亮北伐時歸蜀，深受器重，稱他「涼州上士」。諸葛亮死後繼承遺志，延熙、景耀年間多次北伐，屢與郭淮、陳泰、鄧艾交戰，史稱「九伐中原」。263 年魏滅蜀，他詐降鍾會，企圖藉鍾會之亂復國，事敗被殺。',
    novel: '演義中他與諸葛亮鬥智後才投降；正史是太守猜疑他，他無路可歸才投蜀。' },
  huangyueying: { life: '生卒年不詳', from: '沔南（今湖北襄陽）', src: '《三國志·諸葛亮傳》裴注引《襄陽記》',
    bio: '名士黃承彥之女。黃承彥對諸葛亮說「聞君擇婦，身有醜女，黃頭黑色，而才堪相配」，諸葛亮應允，時人笑稱「莫作孔明擇婦，止得阿承醜女」。正史只記這段婚事，連她的名字都沒有留下。',
    novel: '「黃月英」這個名字與發明木牛流馬、機關的故事，都出自後世民間傳說與戲曲。' },
  madai: { life: '生卒年不詳', from: '扶風郡茂陵縣', src: '《三國志·蜀書·馬超傳》《魏延傳》',
    bio: '馬超的從弟。馬超臨終上疏，說宗族二百餘口被曹操誅殺殆盡，只剩從弟馬岱，託付劉備照顧。諸葛亮死後魏延與楊儀相爭，馬岱奉命追擊，斬殺魏延。後官至平北將軍，封陳倉侯。',
    novel: '演義中「吾敢殺汝」與錦囊妙計斬魏延，是把正史的追斬加油添醋。' },
  xushu: { life: '生卒年不詳', from: '潁川郡長社縣', src: '《三國志·諸葛亮傳》及裴注引《魏略》',
    bio: '本名徐福，少好任俠擊劍，曾為人報仇被捕，被同黨救出後改名，折節向學。在荊州與諸葛亮交好，向劉備推薦「諸葛孔明者，臥龍也」。曹操南下時母親被俘，於是辭別劉備歸曹，後在魏官至右中郎將、御史中丞。',
    novel: '「單福」化名、「走馬薦諸葛」與「一言不發」都是演義加工。' },
  mizhu: { life: '?–約 221', from: '東海郡朐縣', src: '《三國志·蜀書·糜竺傳》',
    bio: '世代經商，家中僮僕食客上萬，資產鉅億。先任徐州牧陶謙別駕，陶謙死後迎劉備為徐州之主。劉備被呂布襲取下邳時，糜竺嫁妹給劉備，並送上奴客二千、金銀資財充作軍資，使劉備重振。入蜀後官至安漢將軍，位在諸葛亮之上。弟弟糜芳降吳後，他慚恨發病而死。' },
  menghuo: { life: '生卒年不詳', from: '益州南中', src: '《三國志·諸葛亮傳》裴注引《漢晉春秋》',
    bio: '南中大族，在當地夷漢之間素有威望。225 年諸葛亮南征，據《漢晉春秋》記載諸葛亮生擒孟獲後放回，前後「七縱七禽」，孟獲終於心服：「公，天威也，南人不復反矣。」後來官至御史中丞。',
    novel: '正史本傳沒有孟獲，七擒七縱只見於裴注；「南蠻王」與藤甲兵、象兵等情節是演義鋪陳。' },
  zhurong: { life: '虛構人物', from: '南中', src: '《三國演義》第九十回',
    bio: '正史沒有這個人。她是《三國演義》創造的角色：孟獲之妻，自稱上古火神祝融氏之後，善使飛刀，曾親自出陣擒住蜀將張嶷、馬忠，最後被諸葛亮設計捉回。',
    novel: '純屬演義虛構。' },
  maliang: { life: '187–222', from: '襄陽郡宜城縣', src: '《三國志·蜀書·馬良傳》',
    bio: '兄弟五人皆有才名，鄉里稱「馬氏五常，白眉最良」，因他眉中有白毛，成語「白眉」由此而來。隨劉備入蜀後任侍中。夷陵之戰時被派往武陵招撫五溪蠻夷，劉備兵敗後遇害。其弟即「失街亭」的馬謖。' },
  fazheng: { life: '176–220', from: '扶風郡郿縣', src: '《三國志·蜀書·法正傳》',
    bio: '原為劉璋部下，不受重用，與張松密謀迎劉備入蜀，成為劉備取益州的內應。後又力勸劉備爭奪漢中，定軍山之戰中建議黃忠乘高進擊，斬殺夏侯淵。劉備對他言聽計從，諸葛亮也說若法正還在，必能勸阻東征。220 年病逝，年 45 歲。' },
  zhoucang: { life: '虛構人物', from: '關西', src: '《三國演義》第二十八回',
    bio: '正史沒有這個人。演義中原為黃巾餘黨，在臥牛山落草，後追隨關羽，為他扛青龍偃月刀；水淹七軍時生擒龐德，關羽死後在麥城自刎。後世關帝廟常塑他持刀侍立在關公身旁。',
    novel: '純屬演義與民間信仰的人物。' },

  // ---------- 吳 ----------
  sunquan: { life: '182–252', from: '吳郡富春縣', src: '《三國志·吳書·吳主傳》',
    bio: '孫堅次子。200 年孫策遇刺，年僅 18 歲的孫權繼承江東基業。208 年聯合劉備於赤壁擊敗曹操；219 年遣呂蒙襲殺關羽奪回荊州，222 年任陸遜於夷陵大破劉備。229 年稱帝，國號吳。在位五十餘年，晚年猜忌多疑，二宮之爭使吳國元氣大傷。曹操曾嘆「生子當如孫仲謀」。',
    novel: '「草船借箭」原型是孫權濡須口坐船受箭；演義把這件事移給了諸葛亮。' },
  sunce: { life: '175–200', from: '吳郡富春縣', src: '《三國志·吳書·孫討逆傳》',
    bio: '孫堅長子，號「小霸王」。父親死後依附袁術，195 年起率千餘人渡江，短短數年間掃平劉繇、王朗、嚴白虎，奠定江東基業。與周瑜同歲交好，分娶大、小喬。200 年打獵時被前吳郡太守許貢的門客刺傷，不久身亡，年僅 26 歲，臨終將基業交給孫權。',
    novel: '演義中「于吉作祟」致死是附會。' },
  zhouyu: { life: '175–210', from: '廬江郡舒縣', src: '《三國志·吳書·周瑜傳》',
    bio: '與孫策總角之交，助其平定江東，娶小喬。孫策死後與張昭共輔孫權。208 年曹操南下，力主抗戰，與程普率軍在赤壁以火攻大破曹軍，又圍攻江陵擊退曹仁。正準備取益州時於巴丘病逝，年 36 歲。精通音律，時人稱「曲有誤，周郎顧」。',
    novel: '演義為了襯托諸葛亮把他寫成心胸狹窄，「三氣周瑜」「既生瑜何生亮」都是虛構；正史稱他「性度恢廓」。' },
  luxun: { life: '183–245', from: '吳郡吳縣', src: '《三國志·吳書·陸遜傳》',
    bio: '江東大族陸氏子弟，娶孫策之女。219 年與呂蒙定計，以謙卑書信麻痺關羽，攻取荊州。222 年夷陵之戰任大都督，堅守七八個月後火燒連營，大破劉備。228 年石亭之戰再敗曹休。後官至丞相，因捲入二宮之爭屢遭孫權責問，憂憤而死。' },
  lvmeng: { life: '178–220', from: '汝南郡富陂縣', src: '《三國志·吳書·呂蒙傳》',
    bio: '少年從軍，原本不讀書，受孫權勸學後發奮進修，魯肅與他談論後驚嘆「非復吳下阿蒙」，他答「士別三日，即更刮目相待」。219 年接替魯肅鎮守陸口，以「白衣渡江」之計偷襲荊州，兵不血刃取得江陵，擒殺關羽，不久病逝。' },
  ganning: { life: '?–約 220', from: '巴郡臨江縣', src: '《三國志·吳書·甘寧傳》',
    bio: '少年時好遊俠，聚眾為盜，身佩鈴鐺，人稱「錦帆賊」。後讀書向學，先依劉表、黃祖不受重用，轉投孫權，獻計攻滅黃祖。濡須之戰時率百餘人夜襲曹營，全身而退，孫權讚「孟德有張遼，孤有興霸，足相敵也」。' },
  taishici: { life: '166–206', from: '東萊郡黃縣', src: '《三國志·吳書·太史慈傳》',
    bio: '以信義著稱，善射。曾單騎突圍為孔融向劉備求救。後依劉繇，在神亭與孫策單挑，奪得孫策的兜鍪。劉繇敗後被孫策收服，孫策解其縛，任為折衝中郎將，負責抵禦劉表，41 歲病逝，臨終嘆「大丈夫生世，當帶七尺之劍，以升天子之階」。' },
  huanggai: { life: '生卒年不詳', from: '零陵郡泉陵縣', src: '《三國志·吳書·黃蓋傳》',
    bio: '孫堅起兵時就追隨左右，歷事孫堅、孫策、孫權三代。赤壁之戰時向周瑜獻火攻之策，並寫信向曹操詐降，率數十艘裝滿柴草、灌注膏油的船衝向曹營，火燒連船，促成大勝。後任武陵太守，平定山越，死於任上。',
    novel: '「苦肉計」挨打是演義虛構；正史只有詐降書信。' },
  sunshangxiang: { life: '生卒年不詳', from: '吳郡富春縣', src: '《三國志·法正傳》《趙雲傳》裴注',
    bio: '孫權之妹，209 年嫁給劉備以鞏固聯盟。史書說她「才捷剛猛，有諸兄之風」，身邊侍婢百餘人皆執刀侍立，劉備每次進房都提心吊膽。劉備入蜀後孫權將她接回東吳，臨行想帶走劉禪，被趙雲、張飛截江攔下。此後下落不明。',
    novel: '正史只稱「孫夫人」，「孫尚香」是後世戲曲取的名字；聽聞劉備死訊投江也是演義情節。' },
  daqiao: { life: '生卒年不詳', from: '廬江郡皖縣', src: '《三國志·吳書·周瑜傳》',
    bio: '橋公的長女，與妹妹都是國色。199 年孫策攻下皖城，自己納大橋，周瑜納小橋。孫策次年遇刺身亡，此後史書沒有她的記載。',
    novel: '正史寫作「橋」，後世才寫成「喬」；「銅雀春深鎖二喬」是杜牧的詩句，演義據此虛構曹操為二喬南征。' },
  zhoutai: { life: '生卒年不詳', from: '九江郡下蔡縣', src: '《三國志·吳書·周泰傳》',
    bio: '與蔣欽同隨孫策。孫權早年在宣城遭山賊突襲，周泰奮身護衛，身受十二處創傷，昏死良久才甦醒。濡須之戰時督軍，部將朱然、徐盛不服，孫權大宴諸將，令周泰解衣，親手指著每道傷疤問其來由，眾將從此服膺。' },
  sunjian: { life: '155–191', from: '吳郡富春縣', src: '《三國志·吳書·孫破虜傳》',
    bio: '自稱孫武之後，17 歲時智退海盜而出名。參與平定黃巾與涼州叛亂。190 年加入關東聯軍討伐董卓，在陽人之戰大破董卓軍、斬殺都督華雄，率先攻入洛陽，傳說於井中得到傳國玉璽。191 年奉袁術之命攻打劉表，在峴山中黃祖部將埋伏的箭身亡。',
    novel: '演義把斬華雄的功勞給了關羽。' },
  xiaoqiao: { life: '生卒年不詳', from: '廬江郡皖縣', src: '《三國志·吳書·周瑜傳》',
    bio: '橋公的次女，199 年嫁給周瑜。周瑜 210 年病逝後，史書沒有她的記載。',
    novel: '與姊姊同為後世詩詞戲曲中的「江東二喬」；諸葛亮以〈銅雀臺賦〉激怒周瑜是演義虛構。' },
  lusu: { life: '172–217', from: '臨淮郡東城縣', src: '《三國志·吳書·魯肅傳》',
    bio: '家境富裕，周瑜向他借糧，他指著一囷米三千斛就送出。由周瑜推薦給孫權，初見即提出「鼎足江東，以觀天下之釁」，是比隆中對更早的三分之策。赤壁之戰前力排眾議主戰，並主張借荊州給劉備共抗曹操。周瑜死後接掌軍隊，與關羽「單刀相會」爭荊州。',
    novel: '演義把他寫成忠厚老實、被諸葛亮耍得團團轉；正史中他是江東最早的戰略家，「單刀赴會」的其實是他。' },
  chengpu: { life: '生卒年不詳', from: '右北平郡土垠縣', src: '《三國志·吳書·程普傳》',
    bio: '隨孫堅征戰黃巾、董卓，歷事孫氏三代，在諸將中年紀最長，人稱「程公」。赤壁之戰與周瑜分任左右督。他起初輕視年輕的周瑜，後來被周瑜的氣度折服，說「與周公瑾交，若飲醇醪，不覺自醉」。' },

  lingtong: { life: '189–217', from: '吳郡餘杭縣', src: '《三國志·吳書·凌統傳》',
    bio: '父親凌操隨孫策、孫權征戰，討伐黃祖時被當時還是黃祖部將的甘寧射殺，凌統十五歲就代領父親的部隊。他一直對甘寧懷恨，孫權只好讓甘寧移防避開。215 年合肥之戰，孫權撤退時在逍遙津遭張遼突襲，凌統率親兵三百人殺入重圍，扶孫權突圍；親兵全部戰死，他自己身受重傷，回營後為部下痛哭，孫權親自用衣袖替他拭淚。早逝，孫權收養了他的兩個兒子。',
    novel: '演義中凌統在濡須口與樂進交戰落馬，甘寧一箭射中樂進救了他，兩人從此和解。' },
  xusheng: { life: '生卒年不詳', from: '琅邪郡莒縣', src: '《三國志·吳書·徐盛傳》',
    bio: '避亂寓居吳郡，以勇氣聞名。孫權統事後任別部司馬，只帶五百人守柴桑，擊退黃祖之子黃射的數千人。曹操攻濡須時，他的蒙衝船被風吹到敵岸，仍上岸奮戰。222 年隨陸遜在夷陵大破劉備。224 年曹丕大舉南征，他建議從建業沿江數百里豎起假城樓、江上浮著戰船；曹丕到廣陵望見，嘆道「魏雖有武騎千群，無所用也」，引兵退去。',
    novel: '演義中赤壁之戰前，徐盛與丁奉奉周瑜之命追殺借東風後離去的諸葛亮，被趙雲一箭射斷船帆而回。' },
  dingfeng: { life: '?–271', from: '廬江郡安豐縣', src: '《三國志·吳書·丁奉傳》',
    bio: '少年時以驍勇為小將，隨甘寧、陸遜、潘璋征戰，屢次斬將奪旗。252 年魏軍攻東興，他率三千人冒雪先登，命令兵士脫下鎧甲、只戴頭盔，拿短兵器登堤；魏軍見他人少，笑而不備，被突襲大破。後來參與誅殺權臣孫綝，歷仕四位吳主，官至大司馬。',
    novel: '演義中他與徐盛奉周瑜之命追殺諸葛亮未果；晚年誅孫綝、雪中奮短兵的情節大致依照正史。' },
  // ---------- 魏 ----------
  caocao: { life: '155–220', from: '沛國譙縣', src: '《三國志·魏書·武帝紀》',
    bio: '宦官曹騰的養孫。196 年迎漢獻帝於許，「奉天子以令不臣」，200 年官渡之戰以少勝多擊敗袁紹，統一北方。208 年南征在赤壁敗於孫劉聯軍。推行屯田、唯才是舉，官至丞相、魏王。善於用兵，也是傑出詩人，〈短歌行〉〈觀滄海〉傳世。220 年病逝洛陽，其子曹丕代漢稱帝，追尊為武帝。',
    novel: '演義以他為奸雄代表。殺呂伯奢一家的事見於裴注，三種記載說法不一；演義把它寫成蓄意殺人，並改成「寧教我負天下人，休教天下人負我」。' },
  caoren: { life: '168–223', from: '沛國譙縣', src: '《三國志·魏書·曹仁傳》',
    bio: '曹操從弟，少好弓馬。赤壁戰後奉命守江陵，周瑜圍城一年，部將牛金被困，他親率數十騎突入重圍救出，眾人嘆服「將軍真天人也」。219 年在樊城被關羽水淹七軍圍困，城牆浸水，他與士卒誓死堅守，等到徐晃救援。曹丕即位後官至大司馬。' },
  xiahoudun: { life: '?–220', from: '沛國譙縣', src: '《三國志·魏書·夏侯惇傳》',
    bio: '14 歲時有人侮辱他的老師，他殺了那個人，從此以剛烈聞名。曹操起兵後最早追隨的將領之一。與呂布作戰時被流矢射中左眼，軍中稱「盲夏侯」，他很厭惡這個稱號，每照鏡子就發怒摔鏡。性情清儉，所得賞賜都分給部下。官至大將軍，曹操死後數月去世。',
    novel: '「拔矢啖睛」（拔箭吃眼珠）是演義情節。' },
  xiahouyuan: { life: '?–219', from: '沛國譙縣', src: '《三國志·魏書·夏侯淵傳》',
    bio: '夏侯惇的族弟，善於長途奔襲，軍中流傳「典軍校尉夏侯淵，三日五百，六日一千」。平定涼州韓遂、馬超餘黨與隴西宋建，威震羌胡。219 年在定軍山與劉備對峙，親自去修補鹿角，被黃忠居高衝下斬殺。曹操曾告誡他「為將當有怯弱時，不可但恃勇也」。' },
  zhangliao: { life: '169–222', from: '雁門郡馬邑縣', src: '《三國志·魏書·張遼傳》',
    bio: '先後跟隨丁原、何進、董卓、呂布，呂布敗亡後歸曹操。白狼山之戰斬殺烏桓單于蹋頓。215 年合肥之戰，孫權率十萬大軍圍城，他只帶八百敢死之士清晨突擊，直衝孫權大營，殺得吳軍披靡，孫權險些被擒，江東傳說「張遼來了」可以止住小兒夜啼。' },
  dianwei: { life: '?–197', from: '陳留郡己吾縣', src: '《三國志·魏書·典韋傳》',
    bio: '形貌魁梧、膂力過人，曾為人報仇，殺人後提著首級從容離開，追兵數百人不敢靠近。歸曹操後任宿衛，常持大雙戟，軍中說「帳下壯士有典君，提一雙戟八十斤」。197 年張繡降而復叛，夜襲曹營，他獨守營門，身被數十創仍格殺多人，最後瞋目大罵而死，掩護曹操脫險。' },
  xuchu: { life: '生卒年不詳', from: '譙國譙縣', src: '《三國志·魏書·許褚傳》',
    bio: '漢末聚集宗族數千家築壁自守，曾投石擊退賊兵，又單手倒拖牛尾行走百餘步。歸曹操後統領宿衛虎士。潼關之戰時曹操渡河遭馬超追擊，他左手舉馬鞍為曹操擋箭、右手撐船，救出曹操。為人謹慎守法，軍中稱為「虎痴」。',
    novel: '「裸衣鬥馬超」是演義情節。' },
  xuhuang: { life: '?–227', from: '河東郡楊縣', src: '《三國志·魏書·徐晃傳》',
    bio: '原為楊奉部將，勸楊奉迎獻帝，後歸曹操，參與官渡、赤壁、潼關等戰役。219 年率軍救援被關羽圍困的樊城，長驅直入擊破關羽包圍，曹操稱讚他「將軍之功，踰孫武、穰苴」，並說他有「周亞夫之風」。為人謹慎，治軍嚴整。' },
  zhanghe: { life: '?–231', from: '河間郡鄚縣', src: '《三國志·魏書·張郃傳》',
    bio: '原為袁紹部將，官渡之戰時因建議救援烏巢不被採納、又遭郭圖讒言，於是投降曹操。此後屢立戰功，夏侯淵死後被推為主帥穩住軍心。228 年在街亭大破馬謖，粉碎諸葛亮第一次北伐。231 年追擊撤退的蜀軍至木門，中箭身亡。' },
  yujin: { life: '?–221', from: '泰山郡鉅平縣', src: '《三國志·魏書·于禁傳》',
    bio: '曹操的五子良將之一，以治軍嚴整著稱。張繡反叛時其他部隊潰亂，唯獨他整軍而退，先築好營壘才去見曹操解釋。219 年率七軍救援樊城，遇上漢水暴漲全軍被淹，向關羽投降。孫權取荊州後將他送回魏國，曹丕命他去謁陵，陵中畫著他投降的情景，他羞愧發病而死。' },
  yuejin: { life: '?–218', from: '陽平郡衛國縣', src: '《三國志·魏書·樂進傳》',
    bio: '身材短小而膽烈過人，曹操起兵時就已追隨。每次攻城作戰常率先登城，因功升遷。官渡之戰斬殺袁紹部將淳于瓊，後與張遼、李典同守合肥。曹操稱讚他與于禁、張遼「武力既弘，計略周備」。' },
  simayi: { life: '179–251', from: '河內郡溫縣', src: '《晉書·宣帝紀》',
    bio: '出身世族，初不願出仕曹操。後為曹丕親信，歷經曹操、曹丕、曹叡、曹芳四代。抵禦諸葛亮北伐，在五丈原堅守不戰拖垮蜀軍；238 年遠征遼東平定公孫淵。249 年發動高平陵之變誅殺曹爽，掌握曹魏大權，為孫子司馬炎建立晉朝奠定基礎，追尊為晉宣帝。',
    novel: '「死諸葛走生仲達」出自當時百姓的諺語；「空城計」被諸葛亮嚇退則是演義虛構。' },
  guojia: { life: '170–207', from: '潁川郡陽翟縣', src: '《三國志·魏書·郭嘉傳》',
    bio: '初投袁紹，認為袁紹不能成事而離開，經荀彧推薦歸曹操，曹操見後說「使孤成大業者，必此人也」。提出「十勝十敗」論堅定曹操對抗袁紹的決心，準確預料孫策將死於刺客之手。隨曹操遠征烏桓，歸途病逝，年僅 38 歲。曹操赤壁大敗後嘆「郭奉孝在，不使孤至此」。' },
  xunyu: { life: '163–212', from: '潁川郡潁陰縣', src: '《三國志·魏書·荀彧傳》',
    bio: '出身潁川荀氏，年少被稱為「王佐之才」。191 年離開袁紹投奔曹操，曹操稱他「吾之子房也」。建議迎奉漢獻帝、堅持官渡相持，又推薦郭嘉、荀攸、鍾繇等大批人才。長年留守許都主持朝政，人稱「荀令君」。後因反對曹操進爵魏公而失寵，憂鬱而死。' },
  jiaxu: { life: '147–223', from: '武威郡姑臧縣', src: '《三國志·魏書·賈詡傳》',
    bio: '董卓死後，勸李傕、郭汜反攻長安，使天下再陷大亂。後輔佐張繡兩次擊敗曹操，再勸張繡在官渡前歸降曹操。潼關之戰獻離間計瓦解馬超、韓遂。曹操問繼承人時以「思袁本初、劉景升父子」一語暗助曹丕。官至太尉，深自謹慎，以 77 歲高壽善終。' },
  zhenji: { life: '183–221', from: '中山國無極縣', src: '《三國志·魏書·后妃傳》',
    bio: '上蔡令甄逸之女，原為袁紹次子袁熙之妻。204 年曹操攻破鄴城，曹丕納她為妻，生下魏明帝曹叡與東鄉公主。曹丕稱帝後寵愛郭皇后，甄氏心懷怨言，221 年被賜死。曹叡即位後追諡文昭皇后。正史沒有記載她的名字。',
    novel: '「甄姬」「甄宓」是後世的稱呼；曹植〈洛神賦〉是為她而寫的說法，出自唐代李善注引的傳說。' },
  caohong: { life: '?–232', from: '沛國譙縣', src: '《三國志·魏書·曹洪傳》',
    bio: '曹操從弟。190 年討董卓時曹操在滎陽兵敗、失去戰馬，曹洪把自己的馬讓給曹操，說「天下可無洪，不可無君」，徒步護送曹操逃脫。家境富豪而性情吝嗇，曾不肯借絹給曹丕，曹丕即位後藉故將他下獄，靠卞太后求情才免死。' },
  zangba: { life: '生卒年不詳', from: '泰山郡華縣', src: '《三國志·魏書·臧霸傳》',
    bio: '18 歲時率數十名門客劫囚救父，因此聞名。漢末在徐州、青州一帶擁兵自立，曾依附呂布。呂布敗亡後歸降曹操，被委以青、徐二州之事，長期鎮守東方，為曹操穩定後方。曹丕時官至執金吾，封良成侯。' },
  caozhen: { life: '?–231', from: '沛國譙縣', src: '《三國志·魏書·曹真傳》',
    bio: '曹操族子，父親為曹操募兵時被殺，曹操憐憫收養，與曹丕一同長大。少年時曾射殺追逐自己的猛虎。曹叡即位後與司馬懿等人受遺詔輔政，主持西線，抵擋諸葛亮第一次北伐，收復隴右三郡。230 年率大軍伐蜀，遇大雨無功而返，次年病逝。' },
  caoxiu: { life: '?–228', from: '沛國譙縣', src: '《三國志·魏書·曹休傳》',
    bio: '曹操族子，曹操稱他「此吾家千里駒也」，令他與曹丕同住。在漢中之戰下辨擊破張飛部將吳蘭。曹丕時都督揚州，屢敗吳軍。228 年中了東吳周魴的詐降之計，深入皖城，在石亭被陸遜大敗，羞憤背上生瘡而死。' },
  pangde: { life: '?–219', from: '南安郡狟道縣', src: '《三國志·魏書·龐德傳》',
    bio: '原為馬騰、馬超部將，後隨張魯，曹操平定漢中後歸降。219 年隨于禁救援樊城，因舊主馬超與堂兄在蜀而被人懷疑，他說「我受國恩，義在效死」，常乘白馬作戰，蜀軍稱「白馬將軍」。漢水暴漲時于禁投降，他死戰不屈，被關羽斬殺。',
    novel: '「抬櫬決戰」（抬著棺材出征）是演義情節。' },
  wenpin: { life: '生卒年不詳', from: '南陽郡宛縣', src: '《三國志·魏書·文聘傳》',
    bio: '原為劉表大將，劉琮投降時他不肯同去，曹操問他為何來遲，他流淚說無法保全劉表的土地，曹操感動而委以重任。此後鎮守江夏數十年，孫權曾率五萬大軍圍攻石陽，他堅守不出使吳軍退走，名震敵國。' },
  zhongyao: { life: '151–230', from: '潁川郡長社縣', src: '《三國志·魏書·鍾繇傳》',
    bio: '以司隸校尉坐鎮關中，安撫馬騰、韓遂等關西諸將，官渡之戰時送來戰馬二千餘匹支援曹操，曹操比喻他為「蕭何守關中」。曹魏建立後官至太傅。也是著名書法家，楷書之祖，與王羲之並稱「鍾王」。其子即滅蜀的鍾會。' },
  liuye: { life: '?–234', from: '淮南郡成德縣', src: '《三國志·魏書·劉曄傳》',
    bio: '漢光武帝之子阜陵王劉延的後代，13 歲時遵母親遺言手刃讒臣。歸曹操後多出奇謀；平定漢中時勸曹操乘勢取蜀，曹操不聽。曹丕時又準確預料孫權只是假意稱臣、劉備必定伐吳。',
    novel: '演義中由他設計霹靂車破袁紹的土山箭樓；正史只記曹操造發石車，沒說是誰設計。' },
  yangxiu: { life: '175–219', from: '弘農郡華陰縣', src: '《三國志·陳思王植傳》裴注引《典略》《續漢書》',
    bio: '出身名門弘農楊氏，四世三公，任曹操主簿，才思敏捷，凡事總能先猜中曹操的心意。與曹植交好，捲入曹丕、曹植的繼承之爭。219 年曹操在漢中與劉備對峙，以「雞肋」為口令，楊修便開始收拾行裝；不久曹操以「漏洩言教，交關諸侯」之罪將他處死。',
    novel: '演義中他因「雞肋」被殺；正史記載的罪名是洩漏軍令與勾結曹植。' },
  guohuai: { life: '?–255', from: '太原郡陽曲縣', src: '《三國志·魏書·郭淮傳》',
    bio: '夏侯淵戰死時收拾殘兵，推舉張郃為帥穩住陣腳。此後鎮守雍涼三十餘年，諸葛亮北伐時搶先佔據北原，在街亭之戰後擊破柳城的高翔；又多次擊退姜維的北伐。官至車騎將軍。' },
  dengai: { life: '197–264', from: '義陽郡棘陽縣', src: '《三國志·魏書·鄧艾傳》',
    bio: '出身寒微，有口吃，任屯田官時常觀察山川地形規劃軍營。獻〈濟河論〉開鑿河渠，在淮南大興屯田。長年在隴西抵擋姜維。263 年伐蜀時率軍從陰平小道翻越七百多里無人之地，以氈裹身滾下山崖，奇襲江油、綿竹，迫使劉禪投降。後被鍾會誣陷謀反，遭殺害。' },
  caozhang: { life: '?–223', from: '沛國譙縣', src: '《三國志·魏書·任城威王彰傳》',
    bio: '曹操與卞夫人所生的次子，膂力過人，能徒手與猛獸格鬥，不喜讀書，只想「為將」。218 年北征烏桓叛亂，身先士卒，鎧甲中箭仍奮戰，大破烏桓，鮮卑首領軻比能因此歸附。曹操大喜，捋著他的鬍鬚說「黃鬚兒竟大奇也」。曹丕即位後他被遣回封國，在京城朝見時暴死。' },
  chengyu: { life: '141–220', from: '東郡東阿縣', src: '《三國志·魏書·程昱傳》',
    bio: '身高八尺三寸，鬚髯漂亮。曹操征陶謙時呂布襲取兗州，只剩鄄城、范、東阿三城，他聯合荀彧堅守，保住了曹操的根據地。官渡之戰前只率七百人守鄄城，認為袁紹不屑來攻，結果正如所料。性格剛戾，與人多有不合。' },
  xunyou: { life: '157–214', from: '潁川郡潁陰縣', src: '《三國志·魏書·荀攸傳》',
    bio: '荀彧的姪子，年紀反而比荀彧大。曾謀刺董卓不成被捕入獄。歸曹操後為軍師，前後獻奇策十二條，包括白馬之戰聲東擊西斬顏良、官渡之戰奇襲烏巢、下邳之戰引水灌城擒呂布。為人謹慎低調，曹操稱讚「公達外愚內智，外怯內勇」。' },
  manchong: { life: '?–242', from: '山陽郡昌邑縣', src: '《三國志·魏書·滿寵傳》',
    bio: '任許縣縣令時執法嚴峻，連曹洪的門客犯法也照樣處決。樊城之戰時力勸曹仁死守，沉白馬與將士盟誓。後接替曹休都督揚州，築合肥新城，多次擊退孫權。為官清廉，死時家無餘財。' },
  lidian: { life: '生卒年不詳', from: '山陽郡鉅野縣', src: '《三國志·魏書·李典傳》',
    bio: '少年好學、不喜武事，從叔父李乾起追隨曹操。博陽之戰時識破劉備的伏兵，勸夏侯惇不要追擊，事後救出中伏的夏侯惇。215 年合肥之戰，他與張遼素來不和，但仍拋開私怨，隨張遼出城突擊孫權。為人謙恭，36 歲去世。' },
  zhonghui: { life: '225–264', from: '潁川郡長社縣', src: '《三國志·魏書·鍾會傳》',
    bio: '鍾繇的幼子，自幼聰慧，被比作張良。在司馬昭手下屢出謀略，平定諸葛誕之亂，被稱為「子房」。263 年與鄧艾分路伐蜀，在劍閣被姜維擋住，鄧艾則偷渡陰平滅蜀。之後他誣陷鄧艾謀反，聯合降將姜維在成都起兵，事敗死於亂軍之中，年僅 40 歲。' },
  caopi: { life: '187–226', from: '沛國譙縣', src: '《三國志·魏書·文帝紀》',
    bio: '曹操與卞夫人的長子，自幼習騎射、讀詩書。與弟弟曹植爭奪繼承人，217 年被立為魏王世子。220 年曹操去世後繼位，同年逼漢獻帝禪讓，建立魏朝，在位期間推行九品中正制。他也是文學家，所著《典論·論文》是中國最早的文學批評專論，〈燕歌行〉是現存最早的完整七言詩。',
    novel: '「七步詩」逼曹植的故事出自《世說新語》，真偽存疑。' },
  chendao: { life: '生卒年不詳', from: '汝南郡', src: '《三國志·蜀書·楊戲傳》所載《季漢輔臣贊》',
    bio: '自豫州時就跟隨劉備，「名位常亞趙雲，俱以忠勇稱」。統領劉備帳下的白毦兵：諸葛亮在給兄長諸葛瑾的信中說，白毦是「先主帳下白毦，西方上兵也」，是劉備的親衛精兵。建興年間官至征西將軍、永安都督，封亭侯，在任上去世。正史記載不多，事蹟附見於《季漢輔臣贊》。',
    novel: '《三國演義》中沒有出場。' },
  guoxiu: { life: '?–253', from: '涼州西平郡', src: '《三國志·魏書·三少帝紀》、《蜀書·費禕傳》',
    bio: '本名郭循，「素有業行，著名西州」。姜維出兵西平時被擄入蜀，劉禪任他為左將軍。他心向魏國，曾想刺殺劉禪而近身不得。253 年正月歲首大會，蜀大將軍費禕歡飲沉醉，郭脩以手刃刺殺費禕，當場被殺。魏詔書稱他「生於擾攘，歷事前代」，追封長樂鄉侯，以其子襲爵。',
    novel: '裴松之認為他刺殺的不是主君，不足以稱義士；《三國演義》只用一句話帶過。' },
  haozhao: { life: '?–229', from: '太原郡', src: '《三國志·魏書·明帝紀》裴注引《魏略》',
    bio: '為人雄壯，少年從軍，屢立戰功，鎮守河西十餘年。228 年冬諸葛亮率數萬人圍攻陳倉，城中只有千餘人；諸葛亮派郝昭的同鄉靳詳勸降，被他拒絕。蜀軍用雲梯、衝車攻城，郝昭用火箭射燒雲梯、用繩子吊石磨砸毀衝車；蜀軍堆土山、挖地道，他就在城內再築重牆、橫挖地道迎擊。晝夜攻守二十餘日，諸葛亮糧盡退兵。魏明帝封他為關內侯。不久病逝，遺命薄葬。',
    novel: '演義中諸葛亮第三次北伐時趁郝昭病重襲取陳倉，郝昭聽聞城破而死。' },
  xiahouba: { life: '生卒年不詳', from: '沛國譙縣', src: '《三國志·魏書·夏侯淵傳》裴注引《魏略》',
    bio: '夏侯淵次子。父親在定軍山戰死，他「常切齒，有報仇之心」，在魏任偏將軍、右將軍，駐守隴西。249 年司馬懿誅殺曹爽，與他交好的夏侯玄被召回洛陽，他擔心受牽連，投奔蜀漢。劉禪對他說「卿父自遇害於行間耳，非我先人之手刃也」，又指著兒子說這是夏侯家的外甥（張飛之妻是夏侯淵的姪女），任他為車騎將軍。後隨姜維北伐。',
    novel: '演義中他降蜀後成為姜維的副將，在洮陽被魏軍伏兵亂箭射死。' },
  caochun: { life: '170–210', from: '沛國譙縣', src: '《三國志·魏書·曹仁傳》附曹純傳',
    bio: '曹仁之弟，十八歲任黃門侍郎，二十歲起隨曹操征戰。統領虎豹騎——從各軍百人將中挑選，號稱天下驍銳。南皮之戰，他的騎兵斬殺袁譚；北征烏桓，又擒獲單于蹋頓。208 年在長坂追擊劉備，一日一夜行三百餘里，擄獲劉備的兩個女兒和輜重，收編散卒。210 年去世，虎豹騎由曹操親自統領。' },
};

SG.LORE = LORE;
export default LORE;
